import { ArrowLeftOutlined } from '@ant-design/icons';
import { Button, Checkbox } from 'antd';
import { useState } from 'react';
import parse from 'html-react-parser';

export default function Stap5(props) {
    const [approve, setApprove] = useState(false);

    //Previous and Next
    const onPreviousStep = () => {
        props.calProgress(80);
        props.previousStep();
    };

    const checkStep4 = async () => {
        const res = await props.step4
            .validateFields()
            .then((res) => {
                props.onFormFinish('', props.data);
            })
            .catch((err) => {
                props.goToStep(4);
                props.calProgress(60);
            });
        return res;
    };

    const checkStep3 = async () => {
        const res = await props.step3
            .validateFields()
            .then((res) => {
                checkStep4();
            })
            .catch((err) => {
                props.goToStep(3);
                props.calProgress(40);
            });
        return res;
    };

    const checkStep2 = async () => {
        const res = await props.step2
            .validateFields()
            .then((res) => {
                checkStep3();
            })
            .catch((err) => {
                props.goToStep(2);
                props.calProgress(20);
            });
        return res;
    };

    const checkStep1 = async () => {
        const res = await props.step1
            .validateFields()
            .then((res) => {
                checkStep2();
            })
            .catch((err) => {
                props.goToStep(1);
                props.calProgress(0);
            });
        return res;
    };

    const allForm = () => {
        checkStep1();
        // props.onFormFinish('', props.data);
    };

    return (
        <div className="flex flex-col gap-y-5">
            <div
                className="rounded-md p-5 h-full"
                style={{
                    backgroundColor: props?.customStyle?.bgColor, //bgColor
                }}
            >
                <div className="space-y-3">
                    <div
                        className="text-xl font-bold px-3"
                        style={{
                            color: props?.fontStyle?.textCardColor,
                        }}
                    >
                        5.{' '}
                        {props.lang === 'TH'
                            ? 'ข้อสงวนสิทธิของผู้ควบคุมข้อมูล (Disclaimer)'
                            : 'Disclaimer of the data controller'}
                    </div>
                    <div style={{ border: '1px solid #DBDBDB' }}></div>
                    <div className="px-3 space-y-4">
                        <div
                            className="whitespace-pre-line"
                            style={{
                                color: props?.fontStyle?.textCardColor,
                                fontSize: props?.fontStyle?.fontSize,
                            }}
                        >
                            {props.lang === 'TH'
                                ? parse(
                                      `${
                                          props?.customForm?.disclaimer
                                              ?.disclaimerTh || '-'
                                      }`
                                  )
                                : parse(
                                      `${
                                          props?.customForm?.disclaimer
                                              ?.disclaimerEn || '-'
                                      }`
                                  )}
                        </div>
                    </div>
                </div>
            </div>
            <div
                className="rounded-md p-5 h-full"
                style={{
                    backgroundColor: props?.customStyle?.bgColor, //bgColor
                }}
            >
                <div className="space-y-3">
                    <div
                        className="text-xl font-bold px-3"
                        style={{
                            color: props?.fontStyle?.textCardColor,
                        }}
                    >
                        6. {props.lang === 'TH' ? 'คำรับรอง' : 'Confirmation'}
                    </div>
                    <div style={{ border: '1px solid #DBDBDB' }}></div>
                    <div className="px-3 space-y-4">
                        <div
                            className="whitespace-pre-line"
                            style={{
                                color: props?.fontStyle?.textCardColor,
                                fontSize: props?.fontStyle?.fontSize,
                            }}
                        >
                            {props.lang === 'TH'
                                ? parse(
                                      `${
                                          props?.customForm?.certificate
                                              ?.certificateTh || '-'
                                      }`
                                  )
                                : parse(
                                      `${
                                          props?.customForm?.certificate
                                              ?.certificateEn || '-'
                                      }`
                                  )}
                        </div>
                        <Checkbox
                            style={{
                                color: props?.fontStyle?.textCardColor,
                                fontSize: props?.fontStyle?.fontSize,
                            }}
                            checked={approve}
                            onChange={(e) => {
                                setApprove(e.target.checked);
                            }}
                        >
                            {props.lang === 'TH'
                                ? 'รับทราบ'
                                : 'Accept the agreement'}
                        </Checkbox>
                        <div className="flex space-x-4 pb-4">
                            <Button
                                style={{
                                    borderColor:
                                        props?.customStyle?.buttonColor,
                                    color: props?.customStyle?.buttonColor,
                                }}
                                type="default"
                                size="large"
                                onClick={onPreviousStep}
                                className="w-[120px]"
                            >
                                <ArrowLeftOutlined />
                                {props.lang === 'TH' ? 'ย้อนกลับ' : 'Previous'}
                            </Button>
                            <Button
                                style={{
                                    backgroundColor:
                                        !approve ||
                                        props?.customStyle?.buttonColor,
                                    color:
                                        !approve ||
                                        props?.fontStyle?.textButtonColor,
                                }}
                                disabled={!approve}
                                type="primary"
                                size="large"
                                htmlType="submit"
                                onClick={() => {
                                    allForm();
                                    // props.onFormFinish('', props.data);
                                }}
                                className="w-[120px]"
                                loading={props?.loadingForm}
                            >
                                {props.lang === 'TH' ? 'ส่งคำขอ' : 'Submit'}
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
